import { Command } from '@redis/client/dist/lib/RESP/types';
import MRANGE_SELECTED_LABELS, { createTransformMRangeSelectedLabelsArguments } from './MRANGE_SELECTED_LABELS';

export default {
  parseCommand: createTransformMRangeSelectedLabelsArguments('TS.MREVRANGE'),
  transformReply: MRANGE_SELECTED_LABELS.transformReply,
} as const satisfies Command;
